import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Upsell } from 'ngx-web-api';

import { Theme } from '../../domain/theme.model';

@Component({
  selector: 'fts-sister-upsells',
  templateUrl: './sister-upsells.component.html',
  styleUrls: ['./sister-upsells.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SisterUpsellsComponent {
  @Input()
  upsellItems: Upsell[];
  @Input()
  theme: Theme;
  @Output()
  upsellItemAdded: EventEmitter<string> = new EventEmitter<string>();

  onUpsellItemAdded(result: string) {
    this.upsellItemAdded.emit(result);
  }
}
